module.exports = __webpack_public_path__ + "static/media/eventagenda.db9a5dcc.jpg";